import PaidIcon from "@mui/icons-material/Paid";
import { ACCOMMODATION_PRICES, DormitoryServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListAccommodationPrices from "./List";

export const resources = {
  isMenu: true,
  icon: <PaidIcon />,
  name: DormitoryServicePath + ACCOMMODATION_PRICES,
  title: "Цени за настаняване",
  list: <ListAccommodationPrices />,
  permission: permissions.canPreviewDormitoryAccommodationPrices,
};
